import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as Highcharts from 'highcharts';
import { DashboardDirectionJuridiqueService } from '../../core/service/dashboard-direction-juridique.service';
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import { ProductiviteByProfileDTO } from '../../core/model/productivite-by-profile-dto';
import { QuantiteDossierByEmployeeDTO } from '../../core/model/quantite-dossier-by-employee-dto';
import { Request } from 'src/app/parametrage/core/model/request';
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { DashboardAllDirectionService } from '../../core/service/dashboard-all-direction.service';

@Component({
  selector: 'app-credit-productivite',
  templateUrl: './credit-productivite.component.html',
  styleUrls: ['./credit-productivite.component.scss'],
  
  //
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  //

})
export class CreditProductiviteComponent implements OnInit {

  codeDirection : String = 'DIRECTION_RISQUE';
  highcharts = Highcharts;
  chartOptionsDossierPeriodeParProfile:any;

  dossierPeriodeParProfile :ChartViewDTO;

  productiviteByProfileDTOs : ProductiviteByProfileDTO[];

  
  displayedEmployeeColumnsList: string[] = [/*'username', */'firstname', 'lastname', 'poste', 'quantiteDossierEnCours', 'quantiteDossierEnRetard', 'quantiteDossierTraite', 'pourcentageDossierEnRetard', 'actions'];
  quantiteDossierByEmployeeDTOs : QuantiteDossierByEmployeeDTO[];

  dossierHistoryArray:Array<Request[]> = [];
  pageHistory:number = 1;
  totalElementsHistory:number = 0;
  filterHistory: String = "";


  constructor(
    private _dashboardAllDirectionService: DashboardAllDirectionService,
    private _requestService : RequestService
    ) 
    {}

  ngOnInit() {
    this.getDossierPeriodeParProfile(this.codeDirection);
    this.getProductiviteByProfile(this.codeDirection);
    this.quantiteDossierByEmployee(this.codeDirection);
  }

  
  getDossierPeriodeParProfile(codeDirection)
  {
    this._dashboardAllDirectionService.dossierPeriodeParProfile(codeDirection)
    .pipe(first())
    .subscribe(
        response => {
        
          this.dossierPeriodeParProfile = response;

         
          this.chartOptionsDossierPeriodeParProfile = {   
            chart: {
              type: "spline"
           },
           title: {
              text: "Dossiers traités par profil"
           },
           subtitle: {
              text: null
           },
           xAxis:{
              categories:this.dossierPeriodeParProfile.categories
           },
           yAxis: {          
              title:{
                 text:"Quantité"
              } 
           },
           tooltip: {
              valueSuffix:null
           },
           
           legend : {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'top',
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,
             
              backgroundColor: (
                    '#FFFFFF'), shadow: true
              },

           series: this.dossierPeriodeParProfile.series
        
         };


          
        },
        error => {
          console.log(error);
        });
  }

  
  
  getProductiviteByProfile(codeDirection)
  {
    this._dashboardAllDirectionService.productiviteByProfile(codeDirection)
    .pipe(first())
    .subscribe(
        response => {
        
          this.productiviteByProfileDTOs = response;

        },
        error => {
          console.log(error);
        });
  }

  
  quantiteDossierByEmployee(codeDirection)
  {
    this._dashboardAllDirectionService.quantiteDossierByEmployee(codeDirection)
    .pipe(first())
    .subscribe(
        response => {
          this.quantiteDossierByEmployeeDTOs = response;
        },
        error => {
          console.log(error);
        });
  }

  


getRequestsHistoryByWorkflowAndUsername(username,workflow,filter,page,size)
{
    this._requestService.getRequestsHistoryByWorkflowAndUsername(workflow,filter,username,"_","","",page,size,"id","desc")
    .pipe(first())
    .subscribe(
        data => {
            this.dossierHistoryArray[username] = data.content;
            this.totalElementsHistory = data.totalElements;
        },
        error => {
            console.log(error);
        });
}


  

}
